import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { CommonWrapper } from '@kanda-libs/ks-component-ts';
import {
  ConfigWrapper,
  DesktopFooter,
  type HomeLinkProps,
} from '@kanda-libs/ks-design-library';

import DesktopHeader from 'components/shared/DesktopHeader';

import { URLS } from '../App/constants';

export interface AppWrapperProps {
  children: JSX.Element;
}

const AppWrapper: FunctionComponent<AppWrapperProps> = function ({ children }) {
  return (
    <>
      <div id="modals" />
      <ConfigWrapper
        linkComponent={Link as FunctionComponent<HomeLinkProps>}
        homeLinkProps={{ to: URLS.home }}
        desktopHeader={DesktopHeader as FunctionComponent<{}>}
        desktopFooter={DesktopFooter}
      >
        <CommonWrapper>{children}</CommonWrapper>
      </ConfigWrapper>
    </>
  );
};

export default AppWrapper;
